import { Outlet } from 'react-router-dom';

import { BRANDING } from '@perplexicon/config';

import { assetUrl } from '../assets/asset-manifest.js';
import { Brand } from '../components/index.js';

/** Branded entry layout for registration, login, and password recovery. */
export function PublicLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <header className="border-b-strong border-brand/70 bg-frame px-4 py-3 tablet:px-6">
        <div className="mx-auto max-w-shell">
          <Brand />
        </div>
      </header>
      <main
        id="main-content"
        tabIndex={-1}
        className="mx-auto flex w-full max-w-shell flex-1 items-stretch px-0 py-0 tablet:px-5 tablet:py-8 wide:px-8"
      >
        <div className="app-frame grid w-full overflow-hidden desktop:grid-cols-[minmax(0,1.1fr)_minmax(22rem,0.9fr)]">
          <img
            src={assetUrl('decorCorner')}
            alt=""
            aria-hidden="true"
            width={64}
            height={64}
            className="pointer-events-none absolute left-1 top-1 z-10 hidden h-10 w-10 opacity-70 desktop:block"
          />
          <img
            src={assetUrl('decorCorner')}
            alt=""
            aria-hidden="true"
            width={64}
            height={64}
            className="pointer-events-none absolute bottom-1 right-1 z-10 hidden h-10 w-10 rotate-180 opacity-70 desktop:block"
          />
          <section
            className="relative hidden min-h-[36rem] overflow-hidden bg-frame desktop:block"
            aria-label={`${BRANDING.appName} introduction`}
          >
            <img
              src={assetUrl('loadingSplash')}
              width={1200}
              height={800}
              alt=""
              aria-hidden="true"
              className="absolute inset-0 h-full w-full object-cover opacity-70"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-page via-frame/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-10 text-textOnDark">
              <p className="brand-type text-3xl">{BRANDING.appName}</p>
              <p className="mt-3 max-w-lg font-editorial text-lg text-textOnDarkMuted">
                {BRANDING.description}
              </p>
            </div>
          </section>
          <section className="parchment-texture flex items-center justify-center bg-parchment px-4 py-10 tablet:px-8">
            <div className="w-full max-w-md">
              <Outlet />
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
